import React from 'react'
import BroadcastManager from '../Components/BroadcastManager'

const Broadcast = () => <BroadcastManager />

export default Broadcast
